import queryString from "query-string";

export default class SummaryBatchSearchParams
{
    constructor(params)
    {
        this.maxCount = "";
        this.sortDesc = "";
        this.id = "";
        /*
        this.batchId = "";
        this.customerBatchId = "";
        this.retailerBatchId = "";
        this.postEnviron = ""; // PRODUCTION | STAGE
        this.itemId = "";
        this.batchNbr = "";
        this.gtin = "";
        this.lotId = "";
        this.growerId = "";
        this.blockid = "";
        this.eventStartDate = ""; // iso8601
        this.eventEndDate = ""; // iso8601
        this.harvestDateStart = ""; // no time yyyy-mm-dd
        this.harvestDateEnd = "" // no time yyyy-mm-dd
        this.shipDateStart = ""; // no time yyyy-mm-dd
        this.shipDateEnd = ""; // no time yyyy-mm-dd
        this.etaDateStart = ""; // no time yyyy-mm-dd
        this.etaDateEnd = ""; // no time yyyy-mm-dd
        this.status = ""; // ok | error 
       */

   
        //this.toApiSearchObject = this.toApiSearchObject.bind(this);
        this.toApiQueryString = this.toApiQueryString.bind(this);
    }

    static isSearchProp(p)
    {
        var typ = typeof p;
        console.log(p + ": " + typ);
        if (Array.isArray(p)) return true; // multi-value parameter
        var isObject = (typ === "function" || typ === "object");  // note that null is an object so it will be an object even if prop=null
        if (isObject || (!p)) return false; // if null, then ignore
        if (p==="") return false;
        if ((p ==="ALL") || (p === "all") || (p === "All")) return false;
        if (p == null) return false;
        return true;
    }


     static toSearchKey(searchParams)
    {
        var result = "";
        for (const [key, value] of Object.entries(searchParams))
        {
            if (SummaryBatchSearchParams.isSearchProp(value))
            {
                let qPiece = key + "=" + value;
                if (result !=="")
                {
                    result = result + "&" + qPiece;
                }
                else {
                    result = qPiece;
                }
            }
        }
        return result;
    }


    toSearchProp(id, searchSchema)
    {
        var searchProp = searchSchema.baseFields.find(b => b.id.toLowerCase() === id.toLowerCase());
        if (searchProp)
        { 
            searchProp.type = "baseField";
            return searchProp;
        }
        if (searchSchema.searchFields)
        {
            searchProp = searchSchema.searchFields.find(b => b.id.toLowerCase() === id.toLowerCase());
            if (searchProp)
            {
                searchProp.type="searchField";
                return searchProp;
            }
        }
        if (searchSchema.childFields) 
        {
            searchProp = searchSchema.childFields.find(b => b.id.toLowerCase() === id.toLowerCase());
            if (searchProp)
            searchProp.type = "childField";
            return searchProp;
        }
        return null;
    } 

    static toApiSearchObject(searchParams, searchSchema)
    {
        var result = {};
        result.childParams = []
;        result.jsonParams = [];
        result.multiValueParams = [];

        for (const [key, value] of Object.entries(searchParams))
        {
            if (SummaryBatchSearchParams.isSearchProp(value, searchSchema))
            {
                var searchProp = searchParams.toSearchProp(key, searchSchema);
                if (searchProp)
                {
                    if (searchProp.type === "baseField")
                    {
                        if (Array.isArray(value))
                        {
                            result.multiValueParams.push(
                                {
                                    id: searchProp.searchParam,
                                    isBaseProp: true,
                                    path: "",
                                    valueType: (searchProp.valueType) ? searchProp.valueType: "string",
                                    searchValues: value
                                }
                            )
                        }
                        else 
                        {
                            result[searchProp.searchParam] = value;
                        }
                    }

                    else if (searchProp.type === "searchField")
                    {
                        if (Array.isArray(value))
                            {
                                result.multiValueParams.push(
                                    {
                                        id: searchProp.searchParam,
                                        isBaseProp: false,
                                        path: searchProp.path,
                                        valueType: (searchProp.valueType) ? searchProp.valueType: "string",
                                        searchValues: value
                                    }
                                )
                            }
                            else 
                            {
                                result.jsonParams.push(
                                    {
                                        id: key, 
                                        path: searchProp.path, 
                                        valueType: (searchProp.valueType) ? searchProp.valueType : "string",
                                        searchValue: value 
                                    }
                                )
                            }
                    }
                    else if (searchProp.type === "childField")
                    {   
                        result.childParams.push(
                            {
                                id: key,
                                factType: searchProp.factType,
                                valueType: (searchProp.valueType) ? searchProp.valueType: "string",
                                searchValue: value
                            },
                        )
                    }
                }
            }
        }
        return result;

    }
    

    toApiQueryString()
    {
        var obj = {
            "maxcount": this.maxCount,
            "id": this.id,
            "gcid": this.gcid,
            "customerNbr": "",
            "eventstartdate": this.eventStartDate,
            "eventenddate": this.eventEndDate
        }
        var allKeysWithValues = [];
        Object.keys(obj).forEach(function(key) {
            if (obj[key] === undefined) return;
            if (obj[key] === "" || obj[key]==="ALL" || obj[key]==="all") return;
            allKeysWithValues.push(key + '=' +  obj[key]);
        });
          var result = allKeysWithValues.join('&');
          //console.log("searchParams Url: " + result);
          return result;
    }
    

    static fromSearchKey(searchKey)
    {
        let result = queryString.parse(searchKey);
        return result;
    }


    validate(){
        return true;
    }
}